import type { EligibleProduct } from "../../types";

import { EligibilityStatus, SaleProgress } from "../../types";
import { VHDP_PRODUCT_SKU } from "./constants";

export interface ShouldShowLongFormAiArgs {
    isLongFormAiEnabled: boolean;
    selectedProduct: EligibleProduct | undefined;
    /** The active task type — the narrative is a voice/chat sale surface, same as the legacy flow. */
    taskType: { isVoice: boolean; isChat: boolean };
}

/**
 * Whether `ProductSaleFlow` shows the Long Form AI narrative surface instead of the legacy checklist.
 * True only when the flag is on, the task is a voice or chat sale (the legacy `IntegratedFlow` renders
 * nothing otherwise — the narrative must not appear on task types the checklist doesn't), and the VHDP
 * pilot offer is actively being sold (the same trigger the checklist uses). The flag decides
 * narrative-vs-checklist; there is no in-surface fallback to the checklist. Pure so the gate matrix can
 * be unit-tested without rendering.
 */
export const shouldShowLongFormAi = ({
    isLongFormAiEnabled,
    selectedProduct,
    taskType,
}: ShouldShowLongFormAiArgs): boolean =>
    isLongFormAiEnabled &&
    (taskType.isVoice || taskType.isChat) &&
    selectedProduct?.productSku === VHDP_PRODUCT_SKU &&
    selectedProduct.saleProgress === SaleProgress.InProgress &&
    selectedProduct.status === EligibilityStatus.Eligible;
